import { render } from "./ConstructionImage.vue?vue&type=template&id=5846b148"
import script from "./ConstructionImage.vue?vue&type=script&lang=js"
export * from "./ConstructionImage.vue?vue&type=script&lang=js"

import "./ConstructionImage.vue?vue&type=style&index=0&id=5846b148&lang=css"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__